import { useEffect, useState } from 'react';
import ChatHeader from './ChatHeader';
import { useChat } from '../../context/ChatContext';

const CHAT_WIDTH = 356;

const Chat = () => {
    const { isChatOpen, enderecoDaCentral } = useChat();
    const [jaAbriu, setJaAbriu] = useState(false);

    useEffect(() => {
        if (isChatOpen) setJaAbriu(true);
    }, [isChatOpen]);

    return (
        <div className='flex-shrink-0 absolute right-0 h-screen lg:relative lg:h-auto transition-[width,margin-left] duration-200' style={{ width: isChatOpen ? CHAT_WIDTH : 0, marginLeft: isChatOpen ? 8 : 0 }}>
            <div className='bg-transparent h-[calc(100%-45px)] flex-shrink-0 rounded-tl-xl shadow lg:shadow-none' style={{ width: CHAT_WIDTH }}>
                <ChatHeader />

                <div className='w-full h-[calc(100%-37px)] flex flex-col relative'>
                    {jaAbriu ? <iframe src={enderecoDaCentral} title='Central de ajuda' allow='microphone; clipboard-write' className='w-full h-full border-0' /> : null}
                </div>
            </div>
        </div>
    )
};

export default Chat;